import {jsx} from 'panel';

import {ButtonEl} from 'common/components/button';
import {ButtonTheme} from 'common/components/button/constants';
import {SvgIconEl} from 'common/components/svg-icon';

import type {QueryEntrySection} from '../index';
import {MetricEntry, QuerySuperEntry} from '../types';

export function RowLabel({
  el,
  index,
  isPlaceholder,
  reportName,
}: {
  el: QueryEntrySection;
  entry: QuerySuperEntry | MetricEntry;
  index: number;
  isPlaceholder: boolean;
  reportName: string;
}) {
  const isClickable = !isPlaceholder && el.attr(`row-index-toggleable`);
  const prefix = el.attr(`row-label-prefix`);
  const hasPrefix = Boolean(prefix);
  const extraClass = reportName ? {[`for-${reportName}`]: true} : {};
  return (
    <>
      {/** optional prefixed grouped label */}
      {hasPrefix && (!el.hasNewQBUI() ? index === 0 : true) && (
        <RowLabelContent
          icon={el.attr(`row-label-prefix-icon`)}
          label={prefix}
          isPlaceholder={isPlaceholder}
          onClick={isClickable && el.helpers.onGroupEntryIndexLabelClicked.bind(el)}
          extraClass={{'is-prefix': true, ...extraClass}}
        />
      )}
      <RowLabelContent
        icon={el.helpers.getRowIcon(index)}
        label={el.helpers.getRowLabel(index)}
        isPlaceholder={isPlaceholder}
        onClick={isClickable && !hasPrefix && el.helpers.onEntryIndexLabelClicked.bind(el, index)}
        hasPrefix={hasPrefix}
        extraClass={extraClass}
      />
    </>
  );
}

function RowLabelContent({
  icon,
  label,
  isPlaceholder,
  onClick,
  hasPrefix = false,
  extraClass,
}: {
  icon: string;
  label: string;
  isPlaceholder: boolean;
  onClick?: (ev: MouseEvent) => void;
  hasPrefix?: boolean;
  extraClass?: Record<string, boolean>;
}) {
  const isClickable = Boolean(onClick);
  const slotName = !isClickable && `selector-icon`;
  return (
    <div
      key={`entry-label-${slotName}-${icon}`}
      sel='.mp-query-entry-label'
      class={{'is-placeholder': isPlaceholder, 'is-clickable': isClickable, ...extraClass}}
      attrs={{elref: `rowLabel`, slot: !isClickable && `selector-icon`}}
    >
      {label && (
        <ButtonEl
          attrs={{
            elref: `rowLabelButton`,
            theme: ButtonTheme.Tertiary,
            'not-focusable': !onClick,
          }}
          class={{
            'is-clickable': isClickable,
            'has-prefix': hasPrefix,
          }}
          on={{click: onClick}}
        >
          {icon ? <SvgIconEl attrs={{icon}} /> : <span>{label}</span>}
        </ButtonEl>
      )}
    </div>
  );
}
